module.exports = __webpack_public_path__ + "img/icon_erweima.036ed330.png";